interface HtmlContentProps {
  html: string;
}

export function HtmlContent({ html }: HtmlContentProps) {
  return (
    <p
      dangerouslySetInnerHTML={{ __html: html }}
      className="text-black rounded-lg bg-secondary px-5 py-3.5 text-base font-normal shadow"
    />
  );
}
